import React from "react";
import { motion } from "framer-motion";
import { fadeUp, viewportOnce } from "../../lib/motion";

/**
 * Numbered manifesto chapter label + big title.
 * tone: 'dark' (charcoal text) | 'light' (white text)
 */
export default function ChapterHeading({ number, kicker, title, tone = "dark", accent = "#ED1C24", className = "" }) {
  const titleColor = tone === "light" ? "text-white" : "text-diallo-charcoal";
  const kickerColor = tone === "light" ? "text-white/60" : "text-diallo-charcoal/50";
  return (
    <div className={className}>
      <motion.div
        variants={fadeUp}
        initial="hidden"
        whileInView="show"
        viewport={viewportOnce}
        className={`mb-4 flex items-center gap-3 font-display text-sm font-semibold tracking-widest uppercase ${kickerColor}`}
      >
        <span style={{ color: accent }}>{number}</span>
        <span className="h-2 w-2 rounded-full" style={{ backgroundColor: accent }} />
        <span>{kicker}</span>
      </motion.div>
      <motion.h2
        variants={fadeUp}
        initial="hidden"
        whileInView="show"
        viewport={viewportOnce}
        className={`font-display font-extrabold tracking-tight text-4xl md:text-5xl lg:text-6xl leading-[1.08] ${titleColor}`}
      >
        {title}
      </motion.h2>
    </div>
  );
}
